import script from "./tool-header-button-item.vue?vue&type=script&setup=true&lang=ts"
export * from "./tool-header-button-item.vue?vue&type=script&setup=true&lang=ts"

import "./tool-header-button-item.vue?vue&type=style&index=0&id=6db674eb&lang=scss"

const __exports__ = script;

export default __exports__